import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { init as sentryInit } from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { store } from 'store/createStore';
import App from 'modules/App';
import Pages from 'pages';
import GlobalStyle from 'styles/globalStyles';
import { ThemeProvider as CustomThemeProvider, useTheme } from 'styles/theme';
import { AvatarProvider } from 'utils/avatar';

if (process.env.REACT_APP_ENV === 'production') {
  sentryInit({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    allowUrls: ['https://app.ruttl.com'],
  });
}

const RuttlApp = () => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <AvatarProvider>
        <App>
          <Pages />
        </App>
      </AvatarProvider>
    </ThemeProvider>
  );
};

render(
  <Provider store={store}>
    <BrowserRouter>
      <CustomThemeProvider>
        <RuttlApp />
      </CustomThemeProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('main'),
);
